module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_invoice_dark-d70017bea0a534a056c3aab297e7db7b.png";